import Model from '@/lib/data/Model';

const fixedDecimals = function (v) {
    return Number.isNaN(v) ? 0 : parseFloat(parseFloat(v).toFixed(2));
};

class VisitAIRisk extends Model {
    fields = [
        { name: 'expected_loss_overall', getter: fixedDecimals },
        { name: 'prediction', type: 'json' },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'read',
            url: '/airisk/result',
            params: ['visit_id', 'language_code'],
        },
    ];
}

export default VisitAIRisk;
